export default "__VITE_ASSET__CcnXh3BC__"